import React, { useEffect, useState } from 'react';
import { DescriptionTitle, CardContainer, FlexCol, TextInput, SelectInput, Button } from '../utilities/exports';
import formdata from '../data/form/form_fyrep.json';
import attributes from '../data/form/attributes_fyrep.json';
import { useDataFY, useErrorFY } from '../hooks/exports';
import { Loader } from '../components/exports';
const FYRepForm = ({ mobile, onState }) => {
	const { data, setData, initialData, updateData } = useDataFY();
	const { error, validate } = useErrorFY();
  
	const [disabled, setDisabled] = useState(true);
	const [loading, setLoading] = useState(false);

	const textfields1 = attributes.textfields1;
	const selectfields = attributes.selectfields;
	const textfields2 = attributes.textfields2;

	useEffect(() => {
		let flag = Object.values(error).every((item) => item === false);
		setDisabled(!flag);
	}, [data, error]);

	useEffect(() => {
		if (!Object.values(data).every((item) => item === '')) {
			localStorage.setItem('data-26', JSON.stringify(data));
		}
	}, [data]);

	const handleSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		const url = "https://recruitment-backend.arnabbhowmik019.workers.dev/fyrep-applications";
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})
			.then((response) => {
				if (response.ok) {
					setData(initialData);
					onState('completed');
					setLoading(false);
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	return (
		<>
			<CardContainer
				form={true}
				className={mobile ? '!px-8' : ''}
				mobile={mobile}
			>
				<Loader loading={loading} />
				<DescriptionTitle
					text='Application Form'
					mobile={mobile}
				/>
				<FlexCol className='!gap-6 !w-full'>
					{textfields1.map((item, index) => (
						<TextInput
							key={index}
							label={item?.label}
							onData={(value) => {
								updateData(item?.key, value);
							}}
							onBlur={(value) => {
								validate(item?.key, value);
							}}
							error={typeof error?.[item?.key] === 'string' ? true : false}
							helpertext={error?.[item?.key]}
							display={data?.[item?.key]}
						/>
					))}
					{selectfields.map((item, index) => (
						<SelectInput
							key={index}
							label={item?.label}
							on={true}
							menu={formdata?.[item?.menu]}
							onData={(value) => {
								updateData(item?.key, value);
							}}
							onBlur={(value) => {
								validate(item?.key, value);
							}}
							display={data?.[item?.key]}
						/>
					))}
					{textfields2.map((item, index) => (
						<TextInput
							key={index}
							label={item?.label}
							rows={item?.key !== 'resume' ? 5 : null}
							placeholder={item?.key !== 'resume' ? item?.label : 'Public Google Drive or Google Docs link'}
							onData={(value) => {
								updateData(item?.key, value);
							}}
							onBlur={(value) => {
								validate(item?.key, value);
							}}
							error={typeof error?.[item?.key] === 'string' ? true : false}
							helpertext={error?.[item?.key]}
							display={data?.[item?.key]}
						/>
					))}
					<Button
						text='Apply'
						className='!px-10 !mt-10'
						onClick={handleSubmit}
						disabled={disabled}
						mobile={true}
					/>
				</FlexCol>
			</CardContainer>
		</>
	);
};

export default FYRepForm;
